import React, { lazy } from 'react';

import { type Route, type Routes } from 'react-resource-router';

import { componentWithSuspense } from '../../utils';
import { AppAccessGate } from '../AppAccessGate';

const AssistantHome = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_dtac-assistant-home" */ '../../pages/assistant/home'
		),
);

const AssistantHomeWithAccess = (): JSX.Element => (
	<AppAccessGate appName="Assistant">
		<AssistantHome />
	</AppAccessGate>
);

const ROUTE_PREFIX = '/assistant' as const;

export const assistantRoutesObject: Record<string, Route> = {
	home: {
		name: 'home',
		path: ROUTE_PREFIX,
		exact: true,
		component: componentWithSuspense(AssistantHomeWithAccess),
	},
} as const;

export const assistantRoutes: Routes = Object.values(assistantRoutesObject);
